<template>
  <div class="card-content">
    <div class="mt-s">
      <div class="mb-5 w-full">
        <fieldset>
          <div class="form-group">
            <input
              v-model="searchQuery"
              type="search"
              class="form-control form-search"
              placeholder="Type to find what you are looking for"
              aria-controls="datatables"
              autofocus
            />
          </div>
        </fieldset>
      </div>

      <div>
        <el-table
          class="table-striped"
          :data="queriedData"
          :default-sort="defaultSort"
          border
        >
          <el-table-column prop="topic" label="Topic" min-width="450">
            <template #default="props">
              <div class="flex">
                <Icon :type="props.row.topicStatus" class="mr-2" />

                <div class="mr-3">
                  {{ props.row.topic }}
                </div>

                <Icon
                  v-for="condition in props.row.conditions"
                  :key="condition"
                  class="mr-2"
                  :type="condition"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="lesson"
            label="Lesson"
            min-width="450"
          >
            <template #default="props">
              <div class="flex">
                <Icon :type="props.row.lessonStatus" />

                <div class="mr-3">
                  {{ props.row.lesson }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="date" label="Start" min-width="150" />
        </el-table>
      </div>

      <!-- <div class="flex justify-between items-center">
        <div>
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>

        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        />

        <div>
          <el-select
            v-model="pagination.perPage"
            class="select-default"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              class="select-default"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn } from "element-ui";
import HelperDate from "@helpers/dates";
import tableConfig from "@providers/table";
import Icon from "@components/UIComponents/TopicIcon/Icon";
import mapper from "@components/UIComponents/TopicIcon/mapper.json";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
    Icon,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expends: [],
      ...tableConfig.data,
      propsToSearch: ["topic", "lesson", "date", "conditions"],
      defaultSort: { prop: "date", order: "ascending" },
    };
  },
  computed: {
    tableData() {
      return this.parseDataTable(this.data);
    },
    ...tableConfig.computed,
  },
  async mounted() {},
  methods: {
    parseDataTable(schedule) {
      return schedule.map(({ lesson, topic, date }) => {
        const item = {
          lesson: lesson.name,
          conditions: this.getIconConditions(topic),
          lessonStatus: this.getLessonStatus(lesson.status),
          topicStatus: this.getTopicStatus(topic.status),
          topic: topic.name,
          date: HelperDate.formatDate(date),
        };
        return item;
      });
    },
    getIconConditions(topic) {
      const conditions = ["seasonal", "compressed", "expiration", "international_procedures"];

      return conditions.filter((cond) => topic[cond]);
    },
    getLessonStatus(status) {
      if (!status) {
        return;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = [];

      if (rejectStatus.includes(iconName)) {
        return;
      }

      return iconName;
    },
    getTopicStatus(status) {
      if (!status) {
        return;
      }

      const stringfiedStatus = String(status);

      const [iconName] = Object.entries(mapper).find(([, value]) => {
        return value.code === stringfiedStatus;
      });

      const rejectStatus = ["behind", "started", "completed", "delivered"];

      if (rejectStatus.includes(iconName)) {
        return;
      }

      return iconName;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/tables";
@import "@/assets/sass/paper/variables";
.training-schedule {
  .custom-icon i {
    &::after,
    &::before {
      margin-right: 5px;
    }
  }
}
</style>
